import { computed } from 'vue';
import { SET_SHOW_INTERNATIONAL_CONTEXT_FORM, SET_SLIDEOUT_ID } from '#shared/types/actions';
import { useSlideoutStore } from '@nuxt-common/atomic-ui/app/stores/useSlideoutStore';

export default function useInternationalSlideout() {
  const navShared = useNavShared();

  const showForm = computed(() => navShared?.showInternationalContextForm);
  const slideoutId = computed(() => navShared?.slideoutId);

  function init(id) {
    navShared?.[SET_SLIDEOUT_ID](id);
  }

  function toggleSlideout() {
    const slideoutStore = useSlideoutStore();
    slideoutStore.toggle(slideoutId.value);
  }

  function openInternationalSlideout() {
    navShared?.[SET_SHOW_INTERNATIONAL_CONTEXT_FORM](true);
    toggleSlideout();
  }

  function onSlideoutClose() {
    navShared?.[SET_SHOW_INTERNATIONAL_CONTEXT_FORM](false);
  }

  return {
    showForm,
    slideoutId,
    init,
    toggleSlideout,
    openInternationalSlideout,
    onSlideoutClose,
  };
}
